import { render, staticRenderFns } from "./ElementPointEmployeeTableColumn.vue?vue&type=template&id=66466a9c&scoped=true"
import script from "./ElementPointEmployeeTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementPointEmployeeTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementPointEmployeeTableColumn.vue?vue&type=style&index=0&id=66466a9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66466a9c",
  null
  
)

export default component.exports